import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ActivityItemTypeService from "../../../../Domain/ActivityItemType/ActivityItemType.service";
import ActivityFeed from "../../../Presentational/ActivityItem/ActivityFeed";
import ActivityService from "../../../../Services/Activity.service";
import useCurrentPersonInfo from "../../../Hooks/useCurrentPersonInfo";
import ItemEventTypeService from "../../../../Domain/ItemEventType/ItemEventType.service";
import MessageSearchFilters from "../../../Presentational/ItemSearchPiece/MessageSearchFilters";
const AdvisorStudentsStudentMessagesTab = (props) => {
    var _a;
    const [messageSearch, setMessageSearch] = React.useState(null);
    const currentPerson = useCurrentPersonInfo();
    const itemSearch = React.useMemo(() => {
        var _a, _b, _c, _d, _e;
        if (currentPerson.data == null) {
            return null;
        }
        if (messageSearch) {
            return {
                global: {
                    activityItemTypeIds: [ActivityItemTypeService.Message],
                    contextPeoplePersonIds: [props.student.personId],
                    pipelineIds: (_a = messageSearch.pipelines) === null || _a === void 0 ? void 0 : _a.map((pipeline) => pipeline.id),
                },
                latestValue: [
                    {
                        // @ts-expect-error - TS2322 - Type 'string[] | undefined' is not assignable to type 'number[] | null | undefined'.
                        types: (_b = messageSearch.messageTypes) === null || _b === void 0 ? void 0 : _b.map((messageType) => messageType.id),
                        createdByPeoplePersonIds: (_c = messageSearch.creators) === null || _c === void 0 ? void 0 : _c.map((creator) => creator.personId),
                        updatedDateFrom: messageSearch.updatedDateFrom,
                        updatedDateTo: messageSearch.updatedDateTo,
                    },
                ],
            };
        }
        return {
            global: {
                contextPeoplePersonIds: [props.student.personId],
                activityItemTypeIds: [ActivityItemTypeService.Message],
                pipelineIds: ((_e = (_d = props.opportunity) === null || _d === void 0 ? void 0 : _d.stage.pipeline) === null || _e === void 0 ? void 0 : _e.id)
                    ? [props.opportunity.stage.pipeline.id]
                    : null,
            },
            latestValue: [],
        };
    }, [
        currentPerson.data,
        messageSearch,
        props.student.personId,
        (_a = props.opportunity) === null || _a === void 0 ? void 0 : _a.stage.pipeline.id,
    ]);
    const poll = React.useCallback(() => ActivityService.areThereRecentEventsForPerson(props.student.personId), [props.student.personId]);
    return (_jsx(ActivityFeed, { search: itemSearch, poll: poll, filterComponent: _jsx(MessageSearchFilters, { onSearch: setMessageSearch, opportunity: props.opportunity }), hideItemEventTypes: [ItemEventTypeService.SentId] }));
};
export default AdvisorStudentsStudentMessagesTab;
